import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    title: "Đăng nhập",
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "forgot-password",
    title: "Quên mật khẩu",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
  {
    key: "reset-password",
    path: "/reset-password",
    title: "Đặt lại mật khẩu",
    component: React.lazy(
      () => import("views/auth-views/authentication/reset-password"),
    ),
  },
  {
    key: "fullpage-place",
    path: "/full-page/place",
    title: "",
    component: React.lazy(() => import("views/full-page/place")),
  },
  {
    key: "fullpage-voucher",
    path: "/full-page/voucher",
    title: "",
    component: React.lazy(() => import("views/full-page/voucher")),
  },
  {
    key: "fullpage-regulation",
    path: "/full-page/regulation",
    title: "",
    component: React.lazy(() => import("views/full-page/vehicleRegulation")),
  },
  {
    key: "fullpage-security",
    path: "/full-page/security",
    title: "",
    component: React.lazy(() => import("views/full-page/security")),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    title: "Default",
    path: `${APP_PREFIX_PATH}/evc-monitor/dashboard`,
    component: React.lazy(
      () => import("views/app-views/evc-monitor/dashboard"),
    ),
  },
  {
    key: "monitor.dashboard",
    title: "Dashboard",
    path: `${APP_PREFIX_PATH}/evc-monitor/dashboard`,
    component: React.lazy(() => import("views/app-views/in-dev")),
  },
  {
    key: "monitor.map",
    title: "Bản đồ",
    path: `${APP_PREFIX_PATH}/evc-monitor/map`,
    component: React.lazy(() => import("views/app-views/evc-monitor/map")),
  },
  {
    key: "monitor.orders",
    title: "Danh sách đơn hàng",
    path: `${APP_PREFIX_PATH}/evc-monitor/orders/*`,
    component: React.lazy(() => import("views/app-views/evc-monitor/orders")),
  },
  {
    key: "monitor.orders.detail",
    title: "Chi tiết đơn hàng",
    path: `${APP_PREFIX_PATH}/evc-monitor/orders/:id`,
    component: React.lazy(
      () => import("views/app-views/evc-monitor/orders/features/DetailOrder"),
    ),
  },
  {
    key: "monitor.trips",
    title: "trips",
    path: `${APP_PREFIX_PATH}/evc-monitor/trips`,
    component: React.lazy(() => import("views/app-views/evc-monitor/trips")),
  },
  {
    key: "monitor.warning",
    title: "warning",
    path: `${APP_PREFIX_PATH}/evc-monitor/warning`,
    component: React.lazy(() => import("views/app-views/evc-monitor/warning")),
  },
  {
    key: "monitor.shifts",
    title: "shifts",
    path: `${APP_PREFIX_PATH}/evc-monitor/shifts`,
    component: React.lazy(() => import("views/app-views/evc-monitor/shifts")),
  },
  {
    key: "evc-commerce.voucher",
    title: "voucher",
    path: `${APP_PREFIX_PATH}/evc-commerce/vouchers/*`,
    component: React.lazy(() => import("views/app-views/evc-commerce/voucher")),
  },
  {
    key: "evc-fleet.driver",
    title: "driver",
    path: `${APP_PREFIX_PATH}/evc-fleet/drivers/*`,
    component: React.lazy(() => import("views/app-views/evc-fleet/driver")),
  },
  {
    key: "evc-fleet.vehicle",
    title: "vehicle",
    path: `${APP_PREFIX_PATH}/evc-fleet/vehicles/*`,
    component: React.lazy(() => import("views/app-views/evc-fleet/vehicle")),
  },
  {
    key: "evc-fleet.routes",
    title: "routes",
    path: `${APP_PREFIX_PATH}/evc-fleet/working-area/*`,
    component: React.lazy(
      () => import("views/app-views/evc-fleet/working-area"),
    ),
  },
  {
    key: "system.accounts",
    title: "accounts",
    path: `${APP_PREFIX_PATH}/evc-system/accounts/*`,
    component: React.lazy(
      () => import("views/app-views/evc-system-administration/employee"),
    ),
  },
  {
    key: "system.activity-log",
    title: "activity-log",
    path: `${APP_PREFIX_PATH}/evc-system/activity-log/*`,
    component: React.lazy(
      () => import("views/app-views/evc-system-administration/activity-log"),
    ),
  },
  {
    key: "settings.customer",
    title: "customer",
    path: `${APP_PREFIX_PATH}/evc-commerce/customers`,
    component: React.lazy(
      () => import("views/app-views/evc-commerce/customer"),
    ),
  },
  {
    key: "settings.setting-system",
    title: "setting-system",
    path: `${APP_PREFIX_PATH}/evc-settings/setting-system/*`,
    component: React.lazy(
      () => import("views/app-views/evc-settings/setting-system"),
    ),
  },
  {
    key: "settings.drive-matching-rules",
    title: "drive-matching-rules",
    path: `${APP_PREFIX_PATH}/evc-settings/drive-matching-rules/*`,
    component: React.lazy(
      () => import("views/app-views/evc-settings/drive-matching-rules"),
    ),
  },
  {
    key: "settings.setting-map",
    title: "setting-map",
    path: `${APP_PREFIX_PATH}/evc-settings/setting-map/*`,
    component: React.lazy(() => import("views/app-views/evc-settings/map")),
  },
  {
    key: "settings.driver-app",
    title: "driver-app",
    path: `${APP_PREFIX_PATH}/evc-settings/driver-app/*`,
    component: React.lazy(
      () => import("views/app-views/evc-settings/driver-app"),
    ),
  },
  {
    key: "settings.late-rules",
    title: "late-rules",
    path: `${APP_PREFIX_PATH}/evc-settings/late-rules/*`,
    component: React.lazy(
      () => import("views/app-views/evc-settings/late-rules"),
    ),
  },
  {
    key: "settings.cancellation-rules",
    title: "cancellation-rules",
    path: `${APP_PREFIX_PATH}/evc-settings/cancellation-rules/*`,
    component: React.lazy(
      () => import("views/app-views/evc-settings/cancellation-rules"),
    ),
  },
  {
    key: "settings.working-area",
    title: "working-area",
    path: `${APP_PREFIX_PATH}/setting-system/working-area/*`,
    component: React.lazy(
      () => import("views/app-views/evc-settings/setting-system/working-area"),
    ),
  },
  {
    key: "settings.bank-accounts",
    title: "bank-accounts",
    path: `${APP_PREFIX_PATH}/evc-settings/bank-accounts/*`,
    component: React.lazy(
      () => import("views/app-views/evc-settings/bank-accounts"),
    ),
  },
  {
    key: "settings.document-code",
    title: "document-code",
    path: `${APP_PREFIX_PATH}/evc-settings/document-code/*`,
    component: React.lazy(
      () => import("views/app-views/evc-settings/document-code"),
    ),
  },
  {
    key: "settings.airlines",
    title: "airlines",
    path: `${APP_PREFIX_PATH}/evc-settings/airlines/*`,
    component: React.lazy(
      () => import("views/app-views/evc-settings/airlines"),
    ),
  },
  {
    key: "finance.pricing",
    title: "",
    path: `${APP_PREFIX_PATH}/evc-finance/pricing/*`,
    component: React.lazy(() => import("views/app-views/evc-finance/pricing")),
  },
  {
    key: "finance.surcharge",
    title: "",
    path: `${APP_PREFIX_PATH}/evc-finance/surcharge/*`,
    component: React.lazy(
      () => import("views/app-views/evc-finance/surcharge"),
    ),
  },
  {
    key: "finance.vehicle-expense",
    title: "",
    path: `${APP_PREFIX_PATH}/evc-finance/vehicle-expense/*`,
    component: React.lazy(
      () => import("views/app-views/evc-finance/vehicle-expense"),
    ),
  },
  {
    key: "reports.orders",
    title: "",
    path: `${APP_PREFIX_PATH}/evc-report/orders/*`,
    component: React.lazy(() => import("views/app-views/evc-report/orders")),
  },
  {
    key: "reports.vehicle-expense",
    title: "",
    path: `${APP_PREFIX_PATH}/evc-report/vehicle-expense/*`,
    component: React.lazy(
      () => import("views/app-views/evc-report/vehicle-expense"),
    ),
  },
  {
    key: "reports.customers",
    title: "",
    path: `${APP_PREFIX_PATH}/evc-report/customers/*`,
    component: React.lazy(() => import("views/app-views/evc-report/customers")),
  },
  {
    key: "reports.fleets",
    title: "",
    path: `${APP_PREFIX_PATH}/evc-report/drivers-vehicles/*`,
    component: React.lazy(
      () => import("views/app-views/evc-report/drivers-vehicles"),
    ),
  },
];
